module.exports = __webpack_public_path__ + "static/media/yancey-official-blog-logo.48b2cc1f.png";